__turbopack_context__.v({
  "alertBox": "Create-module-scss-module__BVrOxa__alertBox",
  "description": "Create-module-scss-module__BVrOxa__description",
  "form": "Create-module-scss-module__BVrOxa__form",
  "formActions": "Create-module-scss-module__BVrOxa__formActions",
  "formContent": "Create-module-scss-module__BVrOxa__formContent",
  "formError": "Create-module-scss-module__BVrOxa__formError",
  "formField": "Create-module-scss-module__BVrOxa__formField",
  "formFields": "Create-module-scss-module__BVrOxa__formFields",
  "formHeader": "Create-module-scss-module__BVrOxa__formHeader",
  "header": "Create-module-scss-module__BVrOxa__header",
});
